import React, { useState, useEffect } from 'react';
import * as Animatable from 'react-native-animatable';
import { 
  useWindowDimensions,
} from 'react-native';

import { HEADER_LOGIN_HEIGHT } from './CMSLayout';
import { COLOR } from 'const';

const Drawer = ({ navigate, show } : any) => {
  const [removed, setRemoved] = useState(true);
  useEffect(() => {
    if (show) {
      setRemoved(false);
    } else {
      setTimeout(() => {
        setRemoved(true);
      }, 500);
    }
  }, [show]);
  return removed ? null : (
    <Animatable.View
      animation={show ? 'fadeInLeft' : 'fadeOutLeft'}
      duration={500}
      style={{
        // width: width,
        // height: height - HEADER_LOGIN_HEIGHT,
        backgroundColor: '#003846',
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        top: HEADER_LOGIN_HEIGHT,
      }}
    >

    </Animatable.View>
  )
};

export default Drawer;